<div class="login-container">
  <div class="login-card">
    <h1>Bienvenido de nuevo</h1>
    <p>Iniciar sesión para continuar</p>

    <!-- ---------------------------------------------------
      -- INCIO SECCIÓN --
      -- --------------------------------------------------- -->

    <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
      <div class="form-group">
        <label>Correo electrónico</label>
        <input type="email" formControlName="email" placeholder="correo@ejemplo.com" />
      </div>

      <div class="form-group">
        <label>Contraseña</label>

        <div class="password_show">
          <input
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            placeholder="***********"
          />

          <button type="button" (click)="togglePassword()">
            <mat-icon>visibility</mat-icon>
          </button>
        </div>
      </div>

      <!-- ---------------------------------------------------
      -- Recordar correo y olvide mi contraseña --
      -- --------------------------------------------------- -->
      <div class="login-option">
        <mat-checkbox formControlName="rememberMe"> Recordarme </mat-checkbox>

        <a class="forget-password" (click)="goToForgotPassword()"> ¿Olvidaste tu contraseña? </a>
      </div>

      <button class="btn-login" type="submit">Iniciar sesión</button>
    </form>

    <div class="register-sectio">
      <span>¿No tienes cuenta?</span>
      <a (click)="solicitarAcceso()">Solicitar acceso </a>
    </div>

    <!-- routerLink="/solicitar-acceso" -->
  </div>
</div>
